import { render, staticRenderFns } from "./EllipsisParagraph.vue?vue&type=template&id=7926b708&"
import script from "./EllipsisParagraph.vue?vue&type=script&lang=js&"
export * from "./EllipsisParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports